import type { LegalDoc } from './types';

export const disclaimerDoc: LegalDoc = {
  slug: 'disclaimer',
  title: 'Disclaimer',
  effectiveDate: '2026-06-15',
  lastUpdated: '2026-10-22',
  intro:
    `This Disclaimer applies to all information, data, screeners, charts, educational content and features made available through the Sansara mobile application and the website at sansarafin.com (the "Platform"). It supplements our Terms of Service and Risk Disclosure. By using the Platform, you accept this Disclaimer.`,
  sections: [
    {
      heading: 'Information and Education Only',
      paragraphs: [
        `All content on the Platform is provided for general information and educational purposes only. It is not, and must not be construed as, investment, financial, legal, accounting or tax advice, nor as a research report, research recommendation, or an offer or solicitation to buy, sell or hold any security or financial product. You should not act, or refrain from acting, on the basis of any content on the Platform without obtaining your own independent professional advice.`,
      ],
    },
    {
      heading: 'Not SEBI-Registered',
      paragraphs: [
        `Sansara is not registered with the Securities and Exchange Board of India (SEBI) as a Research Analyst or as an Investment Adviser, and is not a stockbroker, portfolio manager or mutual fund distributor. We do not provide recommendations, do not name securities with directional intent, and do not provide personalised advice. Where the Platform displays factual market data or screener results, this is neutral, complete information presented without curation or any view on what you should do.`,
      ],
    },
    {
      heading: 'No Guarantee of Accuracy',
      paragraphs: [
        `While we strive to present reliable information, the market data, prices, ratios, corporate-action details and other content are obtained from third-party sources and may be delayed, incomplete, inaccurate or unavailable. We make no representation or warranty, express or implied, as to the accuracy, completeness, reliability or timeliness of any content, and we accept no liability for any error or omission. Always verify data independently before relying on it.`,
      ],
    },
    {
      heading: 'No Guarantee of Returns',
      paragraphs: [
        `Investments in securities markets are subject to market and other risks, and there is no assurance or guarantee of any return or protection of capital. Past performance, historical data, illustrations and examples are provided for educational purposes only and are not indicative of future results. You may lose some or all of your invested capital.`,
      ],
    },
    {
      heading: 'Your Decisions Are Your Own',
      paragraphs: [
        `Any decision you make to buy, sell or hold a security, or to take any other financial action, is made solely by you on your own judgement and at your own risk. Sansara does not exercise discretion over your money or your broker account. If you link a broker account, every order is reviewed and confirmed by you; Sansara does not execute trades on your behalf or automatically.`,
      ],
    },
    {
      heading: 'Third-Party Content and Links',
      paragraphs: [
        `The Platform may include data, content or links provided by third parties, including Zerodha and data vendors. We do not endorse, and are not responsible for, third-party content, products or services, or the practices of any third-party website. Your dealings with third parties are solely between you and them.`,
      ],
    },
    {
      heading: 'Forward-Looking and Illustrative Statements',
      paragraphs: [
        `Any educational illustration that references hypothetical scenarios, historical patterns or general market behaviour is illustrative only. It does not predict the future performance of any security and must not be relied upon as a forecast or recommendation.`,
      ],
    },
    {
      heading: 'Locked Features',
      paragraphs: [
        `Features that would require SEBI registration, exchange/algo empanelment, or another licence or written legal confirmation are intentionally disabled and labelled. Their presence in the interface does not mean any advisory, automated-execution or regulated service is being offered. No such service is offered until the corresponding registration, licence or confirmation is obtained.`,
        `Sansara does not buy, sell, exchange, transfer or hold crypto or any other virtual digital asset for anyone, and never holds the keys to a wallet. It offers none of the virtual digital asset services for which the law requires registration with FIU-IND. You can record crypto only as a value you enter; Sansara does not attach prices to it. Reading a crypto wallet's balance or linking a crypto exchange stays switched off until counsel confirms in writing that read-only tracking is outside the virtual digital asset rules.`,
      ],
    },
    {
      heading: 'Limitation of Liability',
      paragraphs: [
        `To the maximum extent permitted by law, Sansara Finotech Private Limited will not be liable for any loss or damage, including investment or trading losses, arising from your use of, or reliance on, any content or feature of the Platform. This Disclaimer is to be read with the limitation-of-liability provisions of our Terms of Service.`,
      ],
    },
    {
      heading: 'Contact',
      paragraphs: [
        `If you have any question about this Disclaimer, please contact us at grievance@sansarafin.com or support@sansarafin.com.`,
      ],
    },
  ],
};
